module.exports = __webpack_public_path__ + "media/images/lps-life_event_sp-8799435b.png";